<template>
  <div class="right">
    <div class="head">
      <div class="had">
        <i :class="$store.state.boo ? 'el-icon-s-unfold':'el-icon-s-fold'" class="icon" @click="$store.commit('change')" style="margin-left: 1vw;"></i>
        <el-breadcrumb separator="/" style="margin-left: 10px;">
          <template v-for="(item,index) in $route.matched">
            <el-breadcrumb-item :key="item.path" v-if="!(item.meta.title==='首页' && index===1) || !(item.meta.title==='工作台' && index===1)" v-show="!(userType === 'caigou' && index===0)">
              {{ item.meta.title }}
            </el-breadcrumb-item>
          </template>
        </el-breadcrumb>
      </div>
      <div>
        <!-- 采购用户专属入口 -->
        <i class="el-icon-s-goods" style="font-size: 16px; vertical-align: super; color: #0058ff; cursor: pointer;" v-if="userType === 'caigou'"></i>
        <span style="margin: 12px 12px 12px 0; vertical-align: super; color: #0058ff; cursor: pointer;" v-if="userType === 'caigou'" @click="toshop">进入商城</span>

        <!-- 新增：圆形头像（随机背景色）+ 用户名全称 -->
        <span style="margin-left: 10px; display: inline-flex; align-items: center;vertical-align: super">
          <span v-if="userType === 'caigou'"  :style="{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: avatarColor,
            color: '#fff',
            textAlign: 'center',
            lineHeight: '30px',
            fontSize: '14px',
            fontWeight: 'bold',
            display: 'inline-block'
          }">
            {{ user_name ? user_name.charAt(0).toUpperCase() : '' }}
          </span>
          <span v-if="userType !== 'caigou'"  :style="{
            width: '30px',
            height: '30px',
            borderRadius: '7px',
            backgroundColor: avatarColor,
            color: '#fff',
            textAlign: 'center',
            lineHeight: '30px',
            fontSize: '14px',
            fontWeight: 'bold',
            display: 'inline-block'
          }">
            {{ user_name ? user_name.charAt(0).toUpperCase() : '' }}
          </span>
          <span style="margin-left: 6px; color: #333; font-size: 14px;">{{ user_name }}</span>
        </span>

        <!-- 退出按钮 -->
        <i class="el-icon-switch-button" style="margin: 18px; font-size: 30px;  cursor: pointer;" @click="toLogin"></i>
      </div>
    </div>
    <div class="tabs">
      <el-tabs
        v-model="editableTabsValue"
        type="card"
        @tab-remove="removeTab"
        @tab-click="tabClick"
      >
        <el-tab-pane
          v-for="(item,index) in editableTabs"
          :key="index"
          :label="item.title"
          :name="item.name"
          :closable="item.name !== 'Dashboard' && item.name !== 'Statistics'"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      editableTabsValue: 'Dashboard',
      editableTabs: [
        {
          title: '工作台',
          name: 'Dashboard'
        }
      ],
      user_name: '',
      userType: '',
      avatarColor: '#409EFF' // 默认颜色，mounted 中会被随机替换
    }
  },
  watch: {
    $route (to) {
      this.addTab(to)
    }
  },
  mounted () {
    // 生成随机背景色
    this.avatarColor = this.getRandomColor()

    // 原有逻辑
    this.addTab(this.$route)
    this.user_name = localStorage.getItem('user_name')
    this.userType = localStorage.getItem('user_type')
  },
  methods: {
    // 生成随机十六进制颜色
    getRandomColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    toLogin () {
      Cookies.remove('token')
      localStorage.clear()
      this.$router.push('/login')
    },
    toshop () {
      this.$router.push('/Shopindex')
    },
    addTab (to) {
      const { name, meta: { title } } = to
      const boo = this.editableTabs.findIndex(item => item.name === name)
      if (boo === -1) {
        this.editableTabs.push({
          title: title,
          name: name
        })
      }
      this.userType = localStorage.getItem('user_type')
      if (this.userType === 'caigou' && this.editableTabs[0].title === '工作台') {
        this.editableTabs.splice(0, 1)
      }
      this.editableTabsValue = name
    },
    tabClick (tab) {
      const { name } = tab
      this.$router.push({
        name: name
      })
    },
    removeTab (targetName) {
      const tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
              this.$router.push({
                name: nextTab.name
              })
            }
          }
        })
      }
      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
    }
  }
}
</script>

<style scoped>
.right {
  height: 100px;
  /* width: 100%;*/
}
.head {
  background-color: #e5f0ff;
  color: #333;
  line-height: 60px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.tabs {
  width: 100%;
}
.icon {
  vertical-align: middle;
}
.had {
  display: flex;
  line-height: 60px;
}
.had > #title {
  margin-left: 5px;
  cursor: pointer;
  color: rgb(244, 239, 239);
  display: inline-block;
}
.had > #title:nth-child(2) {
  font-weight: 600;
  color: rgb(8, 0, 0);
}
.had > #title:nth-child(2):hover {
  color: aqua;
}
div.el-breadcrumb {
  line-height: 60px;
}
.icon {
  line-height: 60px;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner:nth-child(1) {
  color: black;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 600;
}
</style>
